<div class="card-header d-flex justify-content-between align-items-center">
    <div class="d-flex flex-fill justify-content-between">
        <h5 class="mb-0">Rx Requests</h5>
        <span 
            class="text-muted border-0" 
            [ngbTooltip]="facilityTooltip()"
        >({{ facility()?.name ?? 'No Facility Selected' }})</span>
    </div>
</div>

<div class="card-body">
    <div class="d-flex flex-column border-bottom pb-3">
        <div class="d-flex justify-content-between mb-2">
            <button 
                [disabled]="disabledScan()" 
                class="btn btn-primary" 
                (click)="infoService.openModal()"
            >{{ facility() ? 'Update Selected' : 'Select' }} Facility</button>
            <div class="d-flex">
                <input 
                    #rxNumber
                    (keydown.enter)="newRefill($safeNavigationMigration(rxNumber?.value))"
                    [disabled]="disabledScan()"
                    placeholder="RxNumber"
                    class="form-control"
                />
            </div>
        </div>
        @if (multipleInventories()) {
            <pcg-select 
                class="mb-2"
                placeholder="Inventory..."
                [(ngModel)]="selectedInventoryId"
                [items]="inventories()"
            />
        }
        @if (
            facility() 
            && isFacilityPharmacy()
        ) {
            <button 
                class="btn btn-save" 
                [disabled]="disabledScan()" 
                (click)="newRefill($safeNavigationMigration(rxNumber?.value))"
            >
                @if (disabledScan()) {
                    <span 
                        class="spinner-border spinner-border-sm align-middle mr-1" 
                        role="status" 
                        aria-hidden="true"
                    ></span>
                }
                {{ buttonText() }}
            </button>
        } @else if (facility()) {
            <button 
                class="btn btn-secondary" 
                [disabled]="true"
            >Facility does not Support Requests</button>
        } @else {
            <button 
                class="btn btn-secondary" 
                [disabled]="true"
            >Select Facility To Create Request</button>
        }                
    </div>

    <div 
        #refillList 
        class="item-list scrollbar-hidden" 
        (scroll)="onScroll($event)"
    >
        @if (
            fetching() 
            && page() == 1
        ) {
            <div class="mt-2 pb-1 text-center">
                <span 
                    class="spinner-border spinner-border-sm align-middle mr-1" 
                    role="status" 
                    aria-hidden="true"
                ></span>
                Finding Recent Requests...
            </div>
        } @else {
            @for (refill of recentRefills(); track refill.shipmentId) {
                <a [href]="rowUrl(refill)">                
                    <div class="item-card d-flex flex-column text-dark border-bottom pb-0">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <strong class="mr-2">Request:</strong>
                                <span>{{ refill.shipmentId }}</span>
                            </div>
                            <div>
                                <strong class="mr-2">Step:</strong>
                                <span>{{ convertStepName(refill.currentStep) }}</span>
                            </div>
                            <div class="position-relative">
                                <fa-icon [icon]="fa.bottle" />
                                <span 
                                    class="notification-badge" 
                                    style="--background-color: var(--primary); 
                                    --right: -10px; --width: 1.3em; --height: 1.3em;"
                                >{{ refill.rxCount }}</span>
                            </div>                        
                        </div>
                        <span class="align-self-end small text-muted">{{ refill.dateCreated | utcToLocal | timeAgo }}</span>
                    </div>
                </a>
            } @empty { <div class="text-center text-muted py-3">No recent Requests</div> }
        }

        @if (
            fetching() 
            && page() > 1
        ) {
            <div class="mt-2 pb-1 text-center">
                <span 
                    class="spinner-border spinner-border-sm align-middle mr-1" 
                    role="status" 
                    aria-hidden="true"
                ></span>
                Finding Recent Requests...
            </div>
        }
    </div>
    
    @if (
        !outOfRefills() 
        && !fetching()
    ) {
        <div class="text-center mt-3">
            <button 
                class="btn btn-outline-primary btn-sm" 
                (click)="showMore()"
            >Show Older Refills</button>
        </div>
    }
</div>